import BaseComponent from 'scripts/BaseComponent.js';

export default class RelatedProductOptions extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      valuesContainer: '.js-valuesContainer',
      valuesWrap: '.js-valuesWrap',
      showMoreBtn: '.js-showMoreBtn',
    };

    this.dom = {
      $component: component,
      $valuesContainer: this.$get(this.refs.valuesContainer),
      $valuesWrap: this.$get(this.refs.valuesWrap),
      $showMoreBtn: this.$get(this.refs.showMoreBtn),
    };

    this.state = {
      showMoreActiveClass: 'show-more-active',
    };

    this.mount();
    this.init();
  }

  mount() {
    super.mount();
    window.addEventListener('resize', this.checkOverlaps.bind(this));
  }

  init() {
    this.checkOverlaps();
  }

  checkOverlaps() {
    const { dom, state } = this;
    const containerWidth = dom.$valuesContainer.offsetWidth;
    const valuesWidth = dom.$valuesWrap.offsetWidth;

    if (valuesWidth > containerWidth) {
      dom.$showMoreBtn.classList.add(state.showMoreActiveClass);
    } else {
      dom.$showMoreBtn.classList.remove(state.showMoreActiveClass);
    }
  }
}
